module.exports = __webpack_public_path__ + "static/top-treatments-49f9a1fd1ec90cde60f44a9ca1e41cbc.png";